var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-main page-btns" },
    [
      _c("page-title"),
      _vm._v("\n  " + _vm._s(_vm.amount) + " "),
      _c("el-button", { on: { click: _vm.handle } }, [_vm._v("lingqu")]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }